import { Register } from './components';
import { withoutAuth } from "../../hocs";

const RegisterPage = () => {

  return <Register />;
};

export default withoutAuth(RegisterPage);
